import { CombinedQueriesResult } from '@lifeomic/one-query';
import { QueryObserverResult } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { apiHooks } from '../../../hooks/useRestAPIHooks';
import {
  CompositeReportDefinitionDetail,
  ModelUtils,
  TemplateSummary,
} from '../models';
import { TemplatingItemDetailRawData } from '../types';

export const useCRDTemplates = ({
  compositeReportDefinition,
}: {
  compositeReportDefinition?: CompositeReportDefinitionDetail;
}) => {
  const select = useCallback(
    ({ template }: { template: TemplatingItemDetailRawData }) =>
      ModelUtils.templatingItemSummaryFromRawData(template) as TemplateSummary,
    [],
  );

  const queries = useMemo(
    () =>
      compositeReportDefinition?.sections.map(section => [
        'GET /v1/ai-templates/durable/:durableId',
        { durableId: section.templateId },
        {
          select,
          retry: false,
          refetchOnWindowFocus: false,
          refetchOnReconnect: false,
        },
      ]) ?? [],
    [select, compositeReportDefinition],
  );

  const compositeReportDefinitionTemplatesQuery =
    apiHooks.useCombinedAPIQueries(
      // @ts-expect-error we can transform the data in the select function, react-client types don't support this
      ...queries,
    );

  return compositeReportDefinitionTemplatesQuery as CombinedQueriesResult<
    QueryObserverResult<TemplateSummary>[]
  >;
};
